'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedRelative = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.selectUnits = selectUnits;

var _linguiReact = require('lingui-react');

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _relativeTime = require('./relativeTime');

var _relativeTime2 = _interopRequireDefault(_relativeTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Adapted from the FormattedRelative component included with the react-intl library
// The original can be found here:
// https://github.com/yahoo/react-intl/blob/v2.4.0/src/components/relative.js

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  /* istanbul ignore next */
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return Number.isFinite(aTime) && Number.isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = exports.FormattedRelative = function (_Component) {
  _inherits(FormattedRelative, _Component);

  function FormattedRelative() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormattedRelative);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call.apply(_ref, [this].concat(args))), _this), _this.state = { now: new Date() }, _this.scheduleNextUpdate = function (props, state) {
      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(_this.timer);

      var value = props.value,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !Number.isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      // const unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitDelay = getUnitDelay(selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      _this.timer = setTimeout(function () {
        _this.setState({ now: new Date() });
      }, delay);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormattedRelative, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var nextValue = _ref2.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: new Date() });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          render = _props.render,
          value = _props.value;

      var renderFunc = children || render;
      var timeString = (0, _relativeTime2.default)(value, this.props);

      return renderFunc(timeString);
    }
  }]);

  return FormattedRelative;
}(_react.Component);

FormattedRelative.propTypes = {
  children: _propTypes2.default.func,
  render: _propTypes2.default.func,
  // eslint-disable-next-line react/no-unused-prop-types
  updateInterval: _propTypes2.default.number,
  // eslint-disable-next-line react/forbid-prop-types
  value: _propTypes2.default.any.isRequired
};
FormattedRelative.defaultProps = {
  children: null,
  render: null,
  updateInterval: 1000 * 10
};
exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('FormattedRelative'), (0, _linguiReact.withI18n)())(FormattedRelative);


//////////////////
// WEBPACK FOOTER
// ./node_modules/decisiv-domain-utils/build/components/FormattedRelative/index.js
// module id = 1491
// module chunks = 2